(() => {
  'use strict';
  if (window.__ossJerseyRound7Installed) return;
  window.__ossJerseyRound7Installed = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const text = (value) => String(value == null ? '' : value).trim();
  const parseJson = (node) => {
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (_) { return {}; }
  };

  const config = parseJson(qs('[data-oss-product-config]'));
  const product = parseJson(qs('[data-product-json]'));
  const tags = Array.isArray(config.tags) ? config.tags.map((tag) => text(tag).toLowerCase()) : [];
  const type = text(config.type || product.type).toLowerCase();
  const isJersey = type.includes('jersey') || tags.some((tag) => tag.includes('jersey'));
  if (!isJersey) return;

  const syncOwnNameFields = () => {
    const select = qs('#oss-r3-player-select');
    const fields = qs('.oss-custom-personalization');
    if (!select || !fields) return;

    const ownName = select.value === 'custom';
    fields.hidden = !ownName;
    if (ownName) fields.removeAttribute('hidden');
    else fields.setAttribute('hidden', '');

    const nameInput = qs('#oss-r3-custom-name', fields) || qs('#oss-r3-custom-name');
    const numberInput = qs('#oss-r3-custom-number', fields) || qs('#oss-r3-custom-number');
    const counter = qs('.oss-character-counter', fields) || qs('.oss-character-counter');

    if (nameInput) {
      nameInput.maxLength = 10;
      nameInput.setAttribute('maxlength', '10');
      nameInput.placeholder = 'Max. 10 characters';
      if (nameInput.value.length > 10) nameInput.value = nameInput.value.slice(0, 10);
      if (counter) counter.textContent = `${nameInput.value.length}/10`;
    }
    if (numberInput) {
      numberInput.min = '0';
      numberInput.max = '99';
      numberInput.step = '1';
      numberInput.inputMode = 'numeric';
    }

    const ownOption = qsa('option', select).find((option) => option.value === 'custom');
    const placeholder = qsa('option', select).find((option) => option.value === '');
    if (ownOption) {
      ownOption.textContent = 'Own Name';
      if (placeholder && placeholder.nextElementSibling !== ownOption) {
        placeholder.insertAdjacentElement('afterend', ownOption);
      }
    }
  };

  const enforceExclusivePatch = (changed) => {
    if (!(changed instanceof HTMLInputElement) || changed.type !== 'checkbox' || !changed.checked) return;
    const panel = changed.closest('.oss-patch-panel');
    if (!panel) return;
    qsa('input[type="checkbox"]', panel).forEach((other) => {
      if (other === changed || !other.checked) return;
      other.checked = false;
      other.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const detailIcon = (kind) => {
    if (kind === 'shirt') return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8 4 4 2 4-2 5 3-3 5-2-1v9H8v-9l-2 1-3-5 5-3Z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    if (kind === 'user') return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M5 21c.5-5 3-7 7-7s6.5 2 7 7" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m12 4 2 5 5 .5-4 3.2 1.2 5.3-4.2-2.7L7.8 18 9 12.7 5 9.5 10 9l2-5Z" fill="none" stroke="currentColor" stroke-width="1.2"/></svg>';
  };

  const ensureInfoBlock = () => {
    const details = config.details || {};
    const rows = [
      ['shirt', 'Type of Jersey', text(details.jerseyType) || 'Fan Jersey'],
      ['user', 'Age', text(details.ageGroup) || 'Adult'],
      ['design', 'Official Name & Number Design', text(details.nameNumberDesign) || 'Official Club Design']
    ];

    let box = qs('.oss-product-details');
    if (!box) {
      box = document.createElement('div');
      box.className = 'oss-product-details';
      const heading = document.createElement('div');
      heading.className = 'oss-details-heading';
      heading.textContent = 'About the product';
      box.appendChild(heading);
      rows.forEach(([kind, label, value]) => {
        const row = document.createElement('div');
        row.className = 'oss-detail-row';
        const icon = document.createElement('div');
        icon.className = 'oss-detail-icon';
        icon.innerHTML = detailIcon(kind);
        const copy = document.createElement('div');
        copy.className = 'oss-detail-copy';
        const labelNode = document.createElement('span');
        labelNode.textContent = `${label}:`;
        const valueNode = document.createElement('strong');
        valueNode.textContent = value;
        copy.append(labelNode, valueNode);
        row.append(icon, copy);
        box.appendChild(row);
      });
    } else {
      box.classList.add('oss-product-details--r7');
      const heading = qs('.oss-details-heading', box);
      if (heading) heading.textContent = 'About the product';
      const existingRows = qsa('.oss-detail-row', box);
      rows.forEach(([, label, value], index) => {
        const row = existingRows[index];
        if (!row) return;
        const labelNode = qs('.oss-detail-copy span', row);
        const valueNode = qs('.oss-detail-copy strong', row);
        if (labelNode) labelNode.textContent = `${label}:`;
        if (valueNode) valueNode.textContent = value;
      });
    }
    box.classList.add('oss-product-details--r7');

    const tabContent = qs('.product-detail__detail [data-dynamic-product-content$="-tab1"]');
    const descriptionAnchor = tabContent && tabContent.closest('.product-detail-accordion, .rte, .large-row');
    const fallback = qs('.product-detail__detail .product-detail-accordion, .product-detail__detail .rte');
    const anchor = descriptionAnchor || fallback;
    if (anchor && box.nextElementSibling !== anchor) anchor.insertAdjacentElement('beforebegin', box);
  };

  const normalizePatchPanel = () => {
    const panel = qs('.oss-patch-panel');
    if (!panel) return;
    panel.setAttribute('aria-label', 'Patch selection — choose one');
    qsa('input[type="checkbox"]', panel).forEach((input) => {
      input.setAttribute('aria-describedby', 'oss-r7-patch-help');
    });
    let help = qs('#oss-r7-patch-help', panel);
    if (!help) {
      help = document.createElement('div');
      help.id = 'oss-r7-patch-help';
      help.className = 'oss-r7-patch-help';
      help.textContent = 'Choose one patch option.';
      const heading = qs('.oss-patch-heading', panel);
      if (heading) heading.insertAdjacentElement('afterend', help);
      else panel.prepend(help);
    }
    const checked = qsa('input[type="checkbox"]:checked', panel);
    if (checked.length > 1) {
      checked.slice(1).forEach((input) => {
        input.checked = false;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };

  let refreshTimer = null;
  const refresh = () => {
    syncOwnNameFields();
    normalizePatchPanel();
    ensureInfoBlock();
  };

  document.addEventListener('change', (event) => {
    if (event.target && event.target.id === 'oss-r3-player-select') {
      requestAnimationFrame(syncOwnNameFields);
      window.setTimeout(syncOwnNameFields, 30);
    }
    if (event.target && event.target.matches && event.target.matches('.oss-patch-panel input[type="checkbox"]')) {
      enforceExclusivePatch(event.target);
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target && event.target.id === 'oss-r3-custom-name') {
      const input = event.target;
      if (input.value.length > 10) input.value = input.value.slice(0, 10);
      const counter = qs('.oss-character-counter');
      if (counter) counter.textContent = `${input.value.length}/10`;
    }
  }, true);

  const init = () => {
    document.body.classList.add('oss-round7-ready');
    refresh();
    const root = qs('.product-detail') || document.body;
    new MutationObserver(() => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refresh, 35);
    }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'checked', 'class', 'value'] });
    window.setTimeout(refresh, 120);
    window.setTimeout(refresh, 450);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
